import React from 'react';
import { useTranslation } from "react-i18next";
import ClinicalAlerts from '@/components/ClinicalAlerts';

const ClinicalAlertsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <ClinicalAlerts />
      </div>
    </div>
  );
};

export default ClinicalAlertsPage;
